export default {
	interviews: 'تقييم',

	headers: {
		interviewsName: 'نوع التقييم',
		interviewsDate: 'تاريخ التقييم',
	},

	inputs: {
		interviewsName: 'نوع التقييم',
		interviewsDate: 'تاريخ التقييم',
	},

	add: 'إضافة تقييم',
};
